import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import type { AppState } from '@zerops/zerops/app';
import { ZefForm, ZefFormsManagerService } from '@zerops/zef/forms';
import { FormState, validate } from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';
import { FEATURE_NAME } from './client-add-dialog.constant';

export interface ClientAddFormValue {
  name: string;
}

export type ClientAddFormState = FormState<ClientAddFormValue>;

@Injectable({ providedIn: 'root' })
export class ClientAddForm extends ZefForm<ClientAddFormValue> {
  constructor(
    public store: Store<AppState>,
    public formsManager: ZefFormsManagerService
  ) {
    super(
      store,
      formsManager,
      FEATURE_NAME,
      {
        name: ''
      },
      {
        name: validate(required)
      }
    );
  }
}
